import React, { useState, useEffect } from "react";
import { obtenerPreciosPlanes } from './services/planesServicio';
import apiConfig from './config/apiConfig';
import logo from './imgs/logo_komity.png';
import dummySistema from './imgs/defecto.png';

const API_URL = (apiConfig.api_url || "http://localhost:5000").replace(/\/$/, "");

const config = {
  whatsapp: "+56920039433",
  colors: {
    brand: "#7C3AED",
    action: "#EC1E63",
    darkNavy: "#150826",
    slateText: "#64748B",
    bgLight: "#F5F1FF",
  },
  prices: {
    menuQr: 14990,
    pos: 19990,
    restaurante: 24990,
    pedidosWebAddon: 9990,
  },
};

const formatPrice = (num) => num.toLocaleString("es-CL");
const WA_PRUEBA = `https://wa.me/${config.whatsapp.replace(/\D/g, '')}?text=Hola%21%20Quiero%20conocer%20Komity%20y%20hacer%20una%20prueba%20del%20sistema.`;

// ============================================================
// Componente: Modal de Registro (Prueba Gratis)
// ============================================================
const PLANES_REGISTRO = [
  {
    key: 'MENU_QR',
    icono: '📱',
    nombre: 'Pedidos Web',
    precio: 14990,
    desc: 'Catálogo digital con QR y pedidos online. Ideal para delivery o para complementar tu local.',
    features: ['Catálogo QR', 'Pedidos online', 'Sin comisiones'],
  },
  {
    key: 'POS',
    icono: '🖥️',
    nombre: 'Punto de Venta',
    precio: 19990,
    desc: 'Caja registradora completa con TPV táctil, gestión de caja y reportes de ventas. Menú QR incluido gratis; pedidos online disponible como add-on.',
    features: ['TPV táctil', 'Gestión de caja', 'Reportes de ventas'],
  },
  {
    key: 'RESTAURANTE',
    icono: '🍽️',
    nombre: 'Restaurante Completo',
    precio: 24990,
    desc: 'Todo lo anterior más gestión de mesas y comanda en cocina (KDS). Menú QR incluido gratis; pedidos online disponible como add-on.',
    features: ['TPV + Mesas', 'Menú QR incluido', 'KDS de cocina'],
  },
];

function RegistroModal({ open, onClose }) {
  const [paso, setPaso] = useState(1);
  const [planSeleccionado, setPlanSeleccionado] = useState('');
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', local: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const resetModal = () => { setPaso(1); setPlanSeleccionado(''); setForm({ nombre: '', email: '', telefono: '', local: '', password: '' }); setError(''); };
  const handleClose = () => { resetModal(); onClose(); };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.nombre || !form.email || !form.telefono || !form.password) {
      setError('Completa todos los campos obligatorios.');
      return;
    }
    if (form.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/registro`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, plan: planSeleccionado })
      });
      const data = await res.json();
      if (data.status === 'success') {
        localStorage.setItem('token', data.token);
        localStorage.setItem('negocioId', data.negocioId);
        localStorage.setItem('usuario', JSON.stringify({ nombre: data.nombre, rol: 'ADMIN' }));
        handleClose();
        window.location.href = '/home/';
      } else {
        setError(data.message || 'Error al registrarse');
      }
    } catch (err) {
      setError('Error de conexión con el servidor.');
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <>
      <div
        style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(11,17,32,0.75)', backdropFilter: 'blur(4px)', zIndex: 3000 }}
        onClick={handleClose}
      />
      <div
        style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: '#fff', borderRadius: '24px', padding: '36px 28px', width: '90%', maxWidth: paso === 1 ? '560px' : '440px', zIndex: 3001, boxShadow: '0 25px 60px rgba(0,0,0,0.3)', maxHeight: '92vh', overflowY: 'auto' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={handleClose} style={{ position: 'absolute', top: '14px', right: '16px', background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: config.colors.slateText }}>✕</button>

        {/* Indicador de pasos */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px', justifyContent: 'center' }}>
          {[1, 2].map(n => (
            <React.Fragment key={n}>
              <div style={{ width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem', background: paso >= n ? config.colors.brand : '#e5e7eb', color: paso >= n ? '#fff' : '#9ca3af' }}>{n}</div>
              {n < 2 && <div style={{ flex: 1, height: '2px', background: paso > n ? config.colors.brand : '#e5e7eb', maxWidth: '60px' }} />}
            </React.Fragment>
          ))}
        </div>

        {/* PASO 1: Selección de plan */}
        {paso === 1 && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontWeight: 900, fontSize: '1.3rem', color: config.colors.darkNavy, margin: '0 0 4px' }}>¿Qué necesitas?</h3>
              <p style={{ fontSize: '0.82rem', color: config.colors.slateText, margin: 0 }}>Elige el plan que mejor se ajusta a tu negocio. Puedes cambiarlo después.</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {PLANES_REGISTRO.map(plan => (
                <div
                  key={plan.key}
                  onClick={() => setPlanSeleccionado(plan.key)}
                  style={{ border: `2px solid ${planSeleccionado === plan.key ? config.colors.brand : '#e5e7eb'}`, borderRadius: '14px', padding: '14px 16px', cursor: 'pointer', background: planSeleccionado === plan.key ? config.colors.bgLight : '#fff', transition: 'all 0.2s', display: 'flex', gap: '12px', alignItems: 'flex-start' }}
                >
                  <span style={{ fontSize: '1.6rem', lineHeight: 1, flexShrink: 0 }}>{plan.icono}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                      <span style={{ fontWeight: 800, fontSize: '0.95rem', color: config.colors.darkNavy }}>{plan.nombre}</span>
                      <span style={{ fontWeight: 700, fontSize: '0.85rem', color: config.colors.brand }}>${plan.precio.toLocaleString('es-CL')}/mes</span>
                    </div>
                    <p style={{ fontSize: '0.78rem', color: config.colors.slateText, margin: '0 0 6px', lineHeight: 1.4 }}>{plan.desc}</p>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                      {plan.features.map(f => (
                        <span key={f} style={{ fontSize: '0.7rem', background: '#f3f4f6', borderRadius: '6px', padding: '2px 8px', color: '#4b5563', fontWeight: 600 }}>✓ {f}</span>
                      ))}
                    </div>
                  </div>
                  {planSeleccionado === plan.key && (
                    <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: config.colors.brand, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                      <span style={{ color: '#fff', fontSize: '0.7rem', fontWeight: 800 }}>✓</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <button
              disabled={!planSeleccionado}
              onClick={() => setPaso(2)}
              style={{ width: '100%', marginTop: '18px', padding: '15px', borderRadius: '50px', border: 'none', background: planSeleccionado ? `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})` : '#e5e7eb', color: planSeleccionado ? '#fff' : '#9ca3af', fontWeight: 800, fontSize: '0.9rem', cursor: planSeleccionado ? 'pointer' : 'not-allowed', transition: 'all 0.2s' }}>
              Continuar →
            </button>
          </>
        )}

        {/* PASO 2: Datos del negocio */}
        {paso === 2 && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: config.colors.bgLight, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px', fontSize: '1.4rem' }}>🚀</div>
              <h3 style={{ fontWeight: 900, fontSize: '1.3rem', color: config.colors.darkNavy, margin: '0 0 4px' }}>Prueba Gratis 15 Días</h3>
              <p style={{ fontSize: '0.82rem', color: config.colors.slateText, margin: 0 }}>
                Plan: <strong>{(PLANES_REGISTRO.find(p => p.key === planSeleccionado) || {}).nombre}</strong> &nbsp;·&nbsp; Sin tarjeta de crédito.
              </p>
            </div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input name="nombre" placeholder="Tu nombre completo *" value={form.nombre} onChange={handleChange} style={inputStyle} />
              <input name="email" type="email" placeholder="Correo electrónico *" value={form.email} onChange={handleChange} style={inputStyle} />
              <input name="telefono" placeholder="Teléfono (ej: +56912345678) *" value={form.telefono} onChange={handleChange} style={inputStyle} />
              <input name="local" placeholder="Nombre de tu negocio o local" value={form.local} onChange={handleChange} style={inputStyle} />
              <input name="password" type="password" placeholder="Contraseña * (mín. 6 caracteres)" value={form.password} onChange={handleChange} style={inputStyle} />
              {error && <div style={{ color: '#DC2626', fontSize: '0.8rem', fontWeight: 600, textAlign: 'center' }}>{error}</div>}
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '15px', borderRadius: '50px', border: 'none', background: `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})`, color: '#fff', fontWeight: 800, fontSize: '0.9rem', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'PROCESANDO...' : 'CREAR MI CUENTA GRATIS'}
              </button>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <button type="button" onClick={() => { setPaso(1); setError(''); }} style={{ background: 'none', border: 'none', color: config.colors.slateText, fontSize: '0.8rem', cursor: 'pointer', padding: 0 }}>← Cambiar plan</button>
                <p style={{ fontSize: '0.7rem', color: config.colors.slateText, margin: 0 }}>
                  Aceptas nuestros{' '}
                  <a href="/terminos" target="_blank" rel="noreferrer" style={{ color: config.colors.action, textDecoration: 'none' }}>Términos y Condiciones</a>
                </p>
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );
}

const inputStyle = {
  width: '100%',
  padding: '14px 16px',
  borderRadius: '12px',
  border: '2px solid #E5E7EB',
  fontSize: '0.9rem',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s',
};

// ============================================================
// Componente reutilizable: Botón primario
// ============================================================
function BtnPrimary({ children, href, style, ...props }) {
  const base = {
    background: `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})`,
    color: "#fff",
    borderRadius: "50px",
    padding: "16px 32px",
    border: "none",
    fontWeight: 800,
    fontSize: "0.85rem",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: "0 6px 20px rgba(236,30,99,0.3)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    ...style,
  };
  const Tag = href ? "a" : "button";
  return (
    <Tag
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noreferrer" : undefined}
      style={base}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(236,30,99,0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(236,30,99,0.3)";
      }}
      {...props}
    >
      {children}
    </Tag>
  );
}

// ============================================================
// Componente reutilizable: Botón outline
// ============================================================
function BtnOutline({ children, href, style, ...props }) {
  const base = {
    background: "transparent",
    color: config.colors.darkNavy,
    borderRadius: "50px",
    padding: "16px 32px",
    border: `2px solid ${config.colors.darkNavy}`,
    fontWeight: 800,
    fontSize: "0.85rem",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s",
    ...style,
  };
  const Tag = href ? "a" : "button";
  return (
    <Tag
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noreferrer" : undefined}
      style={base}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = config.colors.darkNavy;
        e.currentTarget.style.color = "#fff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = config.colors.darkNavy;
      }}
      {...props}
    >
      {children}
    </Tag>
  );
}

// ============================================================
// Componente FAQ
// ============================================================
function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        borderBottom: "1px solid #E5E7EB",
        padding: "18px 0",
        cursor: "pointer",
      }}
      onClick={() => setOpen(!open)}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 700,
          fontSize: "0.95rem",
          color: config.colors.darkNavy,
        }}
      >
        <span>{question}</span>
        <span
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.3s",
            color: config.colors.slateText,
          }}
        >
          ▼
        </span>
      </div>
      {open && (
        <div
          style={{
            marginTop: "12px",
            fontSize: "0.85rem",
            color: config.colors.slateText,
            lineHeight: 1.7,
          }}
        >
          {answer}
        </div>
      )}
    </div>
  );
}

// ============================================================
// Componente Step
// ============================================================
function StepCard({ icon, number, title, desc }) {
  return (
    <div
      style={{
        background: "#fff",
        padding: "32px 20px",
        borderRadius: "24px",
        border: "2px solid #F3F4F6",
        textAlign: "center",
        height: "100%",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = config.colors.brand;
        e.currentTarget.style.boxShadow = "0 15px 35px rgba(124,58,237,0.15)";
        e.currentTarget.style.transform = "translateY(-5px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#F3F4F6";
        e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.02)";
        e.currentTarget.style.transform = "none";
      }}
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50%",
          background: number === 2 ? config.colors.brand : config.colors.darkNavy,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px",
          color: number === 2 ? "#000" : "#fff",
        }}
      >
        {icon}
      </div>
      <div
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          background: config.colors.brand,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 900,
          fontSize: "0.85rem",
          marginBottom: "12px",
        }}
      >
        {number}
      </div>
      <h5
        style={{
          fontWeight: 800,
          fontSize: "1.1rem",
          marginBottom: "8px",
          color: config.colors.darkNavy,
        }}
      >
        {title}
      </h5>
      <p style={{ fontSize: "0.85rem", color: config.colors.slateText, lineHeight: 1.6, margin: 0 }}>
        {desc}
      </p>
    </div>
  );
}

// ============================================================
// Componente Plan
// ============================================================
function PlanCard({ icon, name, desc, price, features, popular, buttonText, buttonHref }) {
  return (
    <div
      style={{
        borderRadius: "24px",
        padding: "35px 25px",
        background: "#fff",
        border: popular ? `2px solid ${config.colors.brand}` : "2px solid #E5E7EB",
        boxShadow: popular ? "0 10px 30px rgba(124,58,237,0.2)" : "none",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px)";
        e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = popular ? "0 10px 30px rgba(124,58,237,0.2)" : "none";
      }}
    >
      {popular && (
        <div
          style={{
            position: "absolute",
            top: "-14px",
            left: "50%",
            transform: "translateX(-50%)",
            background: config.colors.brand,
            color: config.colors.darkNavy,
            padding: "6px 20px",
            borderRadius: "50px",
            fontWeight: 900,
            fontSize: "0.75rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          MÁS ELEGIDO
        </div>
      )}

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            background: popular ? config.colors.bgLight : "#F3F4F6",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "12px",
          }}
        >
          {icon}
        </div>
        <h4 style={{ fontWeight: 800, fontSize: "1.2rem", margin: "0 0 4px", color: config.colors.darkNavy }}>
          {name}
        </h4>
        <p style={{ fontSize: "0.8rem", color: config.colors.slateText, margin: "0 0 12px" }}>{desc}</p>
        <h3
          style={{
            fontSize: "2.2rem",
            fontWeight: 900,
            margin: 0,
            color: popular ? config.colors.action : config.colors.darkNavy,
          }}
        >
          ${formatPrice(price)}
        </h3>
        <p style={{ fontSize: "0.8rem", color: config.colors.slateText, margin: 0 }}>/mes + IVA</p>
      </div>

      <div style={{ flex: 1 }}>
        {features.map((f, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "8px 0",
              fontSize: "0.85rem",
              borderBottom: "1px solid #F3F4F6",
              color: f.active ? config.colors.darkNavy : "#9CA3AF",
            }}
          >
            <span style={{ color: "#22C55E", opacity: f.active ? 1 : 0.4 }}>✓</span>
            {f.label}
          </div>
        ))}
      </div>

      <div style={{ marginTop: "24px" }}>
        <BtnPrimary href={buttonHref} style={{ width: popular ? "100%" : "100%" }}>
          {buttonText}
        </BtnPrimary>
      </div>
    </div>
  );
}

// ============================================================
// SECTIONS
// ============================================================

function Hero() {
  return (
    <section
      id="inicio"
      style={{
        paddingTop: "100px",
        paddingBottom: "60px",
        backgroundColor: config.colors.bgLight,
        backgroundImage: "radial-gradient(#7C3AED33 1px, transparent 1px)",
        backgroundSize: "20px 20px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px", textAlign: "center" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            borderRadius: "50px",
            background: "#F3E8FF",
            color: config.colors.brand,
            fontSize: "0.8rem",
            fontWeight: 700,
            marginBottom: "24px",
          }}
        >
          ⚡ SIN COMISIONES POR PEDIDO
        </div>

        <h1
          style={{
            fontSize: "clamp(2.2rem, 6vw, 4rem)",
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: "16px",
            color: config.colors.darkNavy,
            letterSpacing: "-1px",
          }}
        >
          El software que <br />
          <span style={{ color: config.colors.action }}>agiliza tu cocina</span>
        </h1>

        <p
          style={{
            fontSize: "clamp(1rem, 2vw, 1.2rem)",
            color: config.colors.slateText,
            maxWidth: "600px",
            margin: "0 auto 32px",
            lineHeight: 1.6,
          }}
        >
          Desde el catálogo QR hasta el POS y las comandas en cocina: pedidos, mesas y ventas en un solo panel. Sin apps, sin comisiones.
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "32px",
          }}
        >
          <BtnPrimary
            href={WA_PRUEBA}
            style={{ fontSize: "1rem", padding: "18px 40px" }}
          >
            💬 HABLA CON NOSOTROS
          </BtnPrimary>
          <a href="#planes"
            onClick={(e) => { e.preventDefault(); const el = document.getElementById('planes'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
            style={{
              background: "transparent",
              color: config.colors.darkNavy,
              borderRadius: "50px",
              padding: "16px 32px",
              border: `2px solid ${config.colors.darkNavy}`,
              fontWeight: 800,
              fontSize: "0.85rem",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              cursor: "pointer",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              transition: "all 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = config.colors.darkNavy;
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = config.colors.darkNavy;
            }}
          >
            VER PLANES
          </a>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            fontSize: "0.85rem",
            fontWeight: 600,
            color: config.colors.slateText,
          }}
        >
          <span>✓ Sin comisiones</span>
          <span>✓ Sin instalación</span>
          <span>✓ Te contactamos en minutos</span>
        </div>
      </div>
    </section>
  );
}

const FLUJO_STEPS = [
  {
    icon: "📋",
    number: 1,
    title: "Toma el pedido",
    subtitle: "Mostrador o comedor",
    desc: "El garzón anota el pedido en la tablet o el cliente pide desde su mesa con el QR. Sin papel, sin gritar.",
    color: config.colors.brand,
  },
  {
    icon: "🖨️",
    number: 2,
    title: "Se imprime solo",
    subtitle: "Caja + cocina al mismo tiempo",
    desc: "El sistema manda la comanda a cocina y el recibo a caja automáticamente. Sin correr con papelitos.",
    color: "#0EA5E9",
  },
  {
    icon: "🧾",
    number: 3,
    title: "Pre-cuenta",
    subtitle: "Con un clic desde la mesa",
    desc: "El garzón imprime la pre-cuenta al tiro. El cliente revisa antes de pagar. Sin esperar, sin errores.",
    color: "#F59E0B",
  },
  {
    icon: "✅",
    number: 4,
    title: "Cuenta cerrada",
    subtitle: "Boleta lista al instante",
    desc: "Se cierra la mesa, se registra la venta y queda todo en el historial del día. Listo para el siguiente.",
    color: "#22C55E",
  },
];

function ComoFunciona() {
  return (
    <section id="como-funciona" style={{ padding: "80px 0", background: "#fff" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <div style={{ fontSize: "0.75rem", fontWeight: 800, textTransform: "uppercase", color: config.colors.slateText, marginBottom: "8px", letterSpacing: "1px" }}>
            Flujo de trabajo
          </div>
          <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.5rem)", fontWeight: 900, color: config.colors.darkNavy, marginBottom: "12px" }}>
            Cómo funciona en tu local
          </h2>
          <p style={{ color: config.colors.slateText, fontSize: "1.05rem", maxWidth: "560px", margin: "0 auto" }}>
            Del pedido a la boleta en un flujo 100% digital. Sin papeles, sin gritos, sin errores.
          </p>
        </div>

        {/* Dos puntos de entrada */}
        <div style={{ display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap", marginBottom: "20px" }}>
          {[
            {
              icon: "📱",
              label: "Menú QR",
              sub: "El cliente escanea el QR y pide desde su mesa.",
              color: "#0EA5E9",
            },
            {
              icon: "🖥️",
              label: "TPV del garzón",
              sub: "El operador registra el pedido en la tablet.",
              color: config.colors.brand,
            },
          ].map((entry, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: "12px",
              background: "#fff", border: `2px solid ${entry.color}22`,
              borderRadius: "14px", padding: "12px 18px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.04)",
              maxWidth: "280px",
            }}>
              <span style={{
                fontSize: "1.6rem", width: "40px", height: "40px",
                borderRadius: "10px", background: `${entry.color}18`,
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
              }}>{entry.icon}</span>
              <div>
                <div style={{ fontWeight: 800, fontSize: "0.85rem", color: config.colors.darkNavy }}>{entry.label}</div>
                <div style={{ fontSize: "0.72rem", color: config.colors.slateText, lineHeight: 1.4 }}>{entry.sub}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            background: config.colors.bgLight, borderRadius: "20px",
            padding: "5px 14px", fontSize: "0.72rem", fontWeight: 700,
            color: config.colors.brand,
          }}>↓ Ambos flujos entran al mismo sistema</span>
        </div>

        {/* Flujo horizontal */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "0", position: "relative" }}>
          {FLUJO_STEPS.map((step, i) => (
            <div key={i} style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {/* Línea conectora */}
              {i < FLUJO_STEPS.length - 1 && (
                <div style={{
                  position: "absolute",
                  top: "36px",
                  left: "calc(50% + 36px)",
                  right: "-50%",
                  height: "3px",
                  background: `linear-gradient(to right, ${step.color}, ${FLUJO_STEPS[i + 1].color})`,
                  zIndex: 0,
                  display: "block",
                }} className="flujo-line" />
              )}

              {/* Círculo icono */}
              <div style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%",
                background: step.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.8rem",
                marginBottom: "16px",
                zIndex: 1,
                boxShadow: `0 8px 24px ${step.color}40`,
                position: "relative",
              }}>
                {step.icon}
                <div style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  background: config.colors.darkNavy,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.7rem",
                  fontWeight: 900,
                }}>
                  {step.number}
                </div>
              </div>

              {/* Contenido */}
              <div style={{ textAlign: "center", padding: "0 12px 32px" }}>
                <h5 style={{ fontWeight: 900, fontSize: "1.05rem", color: config.colors.darkNavy, margin: "0 0 4px" }}>{step.title}</h5>
                <div style={{ fontSize: "0.75rem", fontWeight: 700, color: step.color, marginBottom: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{step.subtitle}</div>
                <p style={{ fontSize: "0.82rem", color: config.colors.slateText, lineHeight: 1.6, margin: 0 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Banner inferior */}
        <div style={{
          marginTop: "24px",
          background: config.colors.bgLight,
          borderRadius: "20px",
          padding: "24px 32px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
        }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: config.colors.darkNavy, marginBottom: "4px" }}>¿Tienes mesas y mostrador al mismo tiempo?</div>
            <div style={{ fontSize: "0.85rem", color: config.colors.slateText }}>Komity maneja los dos flujos en paralelo. Sin confusión, sin pedidos perdidos.</div>
          </div>
          <a
            href={WA_PRUEBA}
            target="_blank"
            rel="noreferrer"
            style={{
              background: `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})`,
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "50px",
              fontWeight: 800,
              fontSize: "0.85rem",
              textDecoration: "none",
              whiteSpace: "nowrap",
              boxShadow: "0 4px 15px rgba(236,30,99,0.3)",
            }}
          >
            💬 Ver demo en vivo
          </a>
        </div>

        <style>{`
          @media (max-width: 768px) {
            .flujo-line { display: none !important; }
          }
        `}</style>
      </div>
    </section>
  );
}

function CapturasSistema() {
  var pantallas = [
    { img: "/imgs/screens/imagen_menu_qr.png",  label: "📱 Menú QR" },
    { img: "/imgs/screens/imagen_tpv.png",       label: "🖥️ Punto de Venta (TPV)" },
    { img: "/imgs/screens/imagen_comedor.png",   label: "🍽️ Gestión de Comedor" },
  ];

  var qr     = pantallas[0];
  var anchas = pantallas.slice(1);

  var MacFrame = function(p) {
    return (
      <div>
        <div style={{
          borderRadius: "14px", overflow: "hidden",
          boxShadow: "0 20px 50px rgba(0,0,0,0.13)",
          border: "1px solid #dde1e7",
        }}>
          <div style={{
            background: "linear-gradient(180deg, #f0f0f0, #e4e4e4)",
            padding: "9px 14px",
            display: "flex", alignItems: "center", gap: "7px",
          }}>
            <span style={{ width: 11, height: 11, borderRadius: "50%", background: "#FF5F57", display: "inline-block", flexShrink: 0 }} />
            <span style={{ width: 11, height: 11, borderRadius: "50%", background: "#FFBD2E", display: "inline-block", flexShrink: 0 }} />
            <span style={{ width: 11, height: 11, borderRadius: "50%", background: "#28C840", display: "inline-block", flexShrink: 0 }} />
            <div style={{
              flex: 1, marginLeft: 8, background: "#fff", borderRadius: 5,
              padding: "3px 10px", fontSize: "0.68rem", color: "#555",
              fontFamily: "monospace", overflow: "hidden", whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}>🔒 www.komity.cl</div>
          </div>
          <img src={p.img} alt={p.label} style={{ width: "100%", display: "block" }} />
        </div>
        <p style={{
          textAlign: "center", marginTop: "12px",
          fontWeight: 700, fontSize: "0.88rem",
          color: config.colors.darkNavy,
        }}>{p.label}</p>
      </div>
    );
  };

  return (
    <section style={{ padding: "80px 0", background: "#F9FAFB" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <h3 style={{
            fontWeight: 800, fontSize: "clamp(1.3rem, 3vw, 1.7rem)",
            color: config.colors.darkNavy, marginBottom: "8px",
          }}>
            Así se ve Komity en tu negocio
          </h3>
          <p style={{ color: config.colors.slateText, fontSize: "0.95rem" }}>
            Capturas reales del sistema.
          </p>
        </div>

        {/* Layout: QR izquierda | TPV + Comedor apiladas derecha */}
        <div style={{ display: "flex", gap: "28px", alignItems: "flex-start", flexWrap: "wrap" }}>
          {/* Columna izquierda: Menú QR */}
          <div style={{ flexShrink: 0 }}>
            <MacFrame img={qr.img} label={qr.label} />
          </div>

          {/* Columna derecha: TPV y Comedor apiladas */}
          <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "28px" }}>
            {anchas.map(function(p, i) {
              return <MacFrame key={i} img={p.img} label={p.label} />;
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

function Sectores() {
  const items = [
    "🍕 Pizzerías",
    "🍔 Comida rápida",
    "🥗 Delivery saludable",
    "☕ Cafeterías",
    "🍣 Sushi",
    "🌮 Fuentes de soda",
    "🍦 Heladerías",
    "🥪 Sandwich",
  ];
  return (
    <section style={{ padding: "60px 0", background: "#F9FAFB" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px", textAlign: "center" }}>
        <h3
          style={{
            fontWeight: 800,
            fontSize: "1.3rem",
            marginBottom: "24px",
            color: config.colors.darkNavy,
          }}
        >
          Ideal para:
        </h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {items.map((item, i) => (
            <span
              key={i}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 18px",
                borderRadius: "14px",
                background: "#fff",
                border: "2px solid #F3F4F6",
                fontWeight: 700,
                fontSize: "0.9rem",
                color: config.colors.darkNavy,
                transition: "0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = config.colors.brand;
                e.currentTarget.style.background = config.colors.bgLight;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#F3F4F6";
                e.currentTarget.style.background = "#fff";
              }}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

function Planes() {
  const [precios, setPrecios] = useState({ MENU_QR: 14990, POS: 19990, RESTAURANTE: 24990, PEDIDOS_WEB_ADDON: 9990 });
  useEffect(function() {
    obtenerPreciosPlanes().then(function(p) { setPrecios(p); });
  }, []);

  return (
    <section id="planes" style={{ padding: "80px 0", background: "#F3F4F6" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <div
            style={{
              fontSize: "0.75rem",
              fontWeight: 800,
              textTransform: "uppercase",
              color: config.colors.slateText,
              marginBottom: "8px",
            }}
          >
            Elige el plan que necesites
          </div>
          <h2
            style={{
              fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
              fontWeight: 900,
              color: config.colors.darkNavy,
              marginBottom: "8px",
            }}
          >
            Planes flexibles para tu negocio
          </h2>
          <p style={{ color: config.colors.slateText, fontSize: "1rem" }}>
            Todos incluyen 15 días de prueba gratuita. Sin tarjeta.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
            alignItems: "stretch",
          }}
        >
          {/* 📱 PLAN 1: KOMITY PEDIDOS WEB */}
          <PlanCard
            icon={<span style={{ fontSize: "1.4rem" }}>📱</span>}
            name="Komity Pedidos Web"
            desc="Para negocios que quieren su catálogo digital y vender online"
            price={precios.MENU_QR}
            buttonText="ELEGIR PEDIDOS WEB"
            buttonHref={`https://wa.me/${config.whatsapp}?text=Hola! Quiero el plan Komity Pedidos Web ($${formatPrice(precios.MENU_QR)}/mes).`}
            features={[
              { label: "Catálogo QR", active: true },
              { label: "Productos y categorías", active: true },
              { label: "Pedidos online", active: true },
              { label: "Panel de pedidos", active: true },
              { label: "Retiro", active: true },
              { label: "Despacho", active: true },
              { label: "Configuración de horarios", active: true },
              { label: "POS / Caja / Mesas", active: false },
            ]}
          />

          {/* 🏪 PLAN 2: KOMITY POS TAKE AWAY */}
          <PlanCard
            icon={<span style={{ fontSize: "1.4rem" }}>🏪</span>}
            name="Komity POS Take Away"
            desc="Para negocios que venden solo en el local, para llevar, sin mesas"
            price={precios.POS}
            buttonText="ELEGIR POS TAKE AWAY"
            buttonHref={`https://wa.me/${config.whatsapp}?text=Hola! Quiero el plan Komity POS Take Away ($${formatPrice(precios.POS)}/mes).`}
            features={[
              { label: "Punto de Venta", active: true },
              { label: "Caja", active: true },
              { label: "Venta rápida", active: true },
              { label: "Impresión de comandas", active: true },
              { label: "Historial de ventas", active: true },
              { label: "Menú QR incluido", active: true },
              { label: `Pedidos online (add-on +$${formatPrice(precios.PEDIDOS_WEB_ADDON)})`, active: false },
              { label: "Gestión de mesas", active: false },
            ]}
          />

          {/* 🍽️ PLAN 3: PLAN RESTAURANTE */}
          <PlanCard
            icon={<span style={{ fontSize: "1.4rem" }}>🍽️</span>}
            name="Plan Restaurante"
            desc="La solución completa: POS y gestión de mesas. Menú QR incluido gratis"
            price={precios.RESTAURANTE}
            buttonText="ELEGIR PLAN RESTAURANTE"
            buttonHref={`https://wa.me/${config.whatsapp}?text=Hola! Quiero el Plan Restaurante ($${formatPrice(precios.RESTAURANTE)}/mes).`}
            popular
            features={[
              { label: "Todo lo de POS Take Away", active: true },
              { label: "Catálogo QR (Menú QR incluido)", active: true },
              { label: "Punto de Venta y Caja", active: true },
              { label: "Impresión de comandas", active: true },
              { label: "Gestión de mesas", active: true },
              { label: "Historial de ventas", active: true },
              { label: `Pedidos online (add-on +$${formatPrice(precios.PEDIDOS_WEB_ADDON)})`, active: false },
            ]}
          />
        </div>

        <div style={{ textAlign: "center", marginTop: "32px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 24px",
              borderRadius: "50px",
              background: "#F3F4F6",
              fontSize: "0.9rem",
              fontWeight: 600,
              color: config.colors.darkNavy,
            }}
          >
            <span>💡 ¿No sabes cuál elegir?</span>
            <a
              href={`https://wa.me/${config.whatsapp}?text=Hola! No sé qué plan elegir. Ayúdame.`}
              target="_blank"
              rel="noreferrer"
              style={{ color: config.colors.action, fontWeight: 800, textDecoration: "none" }}
            >
              Te ayudamos gratis →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Beneficios() {
  const items = [
    {
      icon: "🛡️",
      title: "Sin comisiones",
      desc: "A diferencia de PedidosYa o Uber, no cobramos por pedido. Pagas solo tu plan fijo mensual.",
    },
    {
      icon: "📱",
      title: "Sin app del cliente",
      desc: "Todo funciona desde el navegador. El cliente escanea el QR y ve la carta al instante.",
    },
    {
      icon: "⏰",
      title: "Disponible 24/7",
      desc: "Tus clientes pueden pedir a cualquier hora. Automatizado, sin que hagas nada.",
    },
    /* Delivery propio: oculto temporalmente */
  ];
  return (
    <section style={{ padding: "80px 0", background: "#fff" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "32px",
          }}
        >
          {items.map((item, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "16px" }}>{item.icon}</div>
              <h5
                style={{
                  fontWeight: 800,
                  fontSize: "1.1rem",
                  marginBottom: "8px",
                  color: config.colors.darkNavy,
                }}
              >
                {item.title}
              </h5>
              <p style={{ fontSize: "0.85rem", color: config.colors.slateText, lineHeight: 1.6, margin: 0 }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQ() {
  return (
    <section id="faq" style={{ padding: "80px 0", background: "#F9FAFB" }}>
      <div style={{ maxWidth: "700px", margin: "0 auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2
            style={{
              fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
              fontWeight: 900,
              color: config.colors.darkNavy,
            }}
          >
            Preguntas frecuentes
          </h2>
        </div>
        <FaqItem
          question="¿Necesito una tablet o pantalla táctil?"
          answer="No. Solo imprimes el código QR y lo pegas en la mesa. Tus clientes usan su propio celular."
        />
        <FaqItem
          question="¿El cliente necesita instalar una app?"
          answer="No, todo funciona desde el navegador del celular. Escanea el QR y listo."
        />
        <FaqItem
          question="¿Cómo llegan los pedidos online?"
          answer="El cliente pide desde el catálogo y el pedido llega automáticamente a tu panel de administración y te notifica por WhatsApp. Incluido en el plan Komity Pedidos Web, y disponible como add-on en POS y Restaurante."
        />
        <FaqItem
          question="¿Puedo recibir pedidos delivery?"
          answer="Sí. El cliente puede pedir desde su casa, seleccionar dirección en el mapa y elegir despacho o retiro."
        />
        <FaqItem
          question="¿Cómo me pagan los clientes?"
          answer="Tú recibes el pago directo. El cliente paga en efectivo al recibir o por transferencia bancaria. No pasamos por un intermediario."
        />
        <FaqItem
          question="¿Puedo actualizar el menú yo mismo?"
          answer="Sí. Desde tu panel de administración puedes agregar, modificar o eliminar productos, precios, fotos y categorías al instante."
        />
        <FaqItem
          question="¿Puedo probar antes de pagar?"
          answer="Sí. Todos los planes incluyen 15 días de prueba gratuita. Sin tarjeta de crédito, sin compromiso."
        />
        <FaqItem
          question="¿Qué pasa si necesito factura?"
          answer="Emitimos boleta electrónica por cada pago. Si necesitas factura, conversémoslo."
        />
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section
      style={{
        padding: "80px 0",
        background: `linear-gradient(135deg, ${config.colors.darkNavy} 0%, #1f2937 100%)`,
        color: "#fff",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "600px", margin: "0 auto", padding: "0 20px" }}>
        <h2
          style={{
            fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
            fontWeight: 900,
            marginBottom: "12px",
          }}
        >
          ¿Listo para digitalizar tu local?
        </h2>
        <p style={{ fontSize: "1.1rem", opacity: 0.9, marginBottom: "32px" }}>
          Escríbenos y te mostramos el sistema en vivo.
        </p>
          <a
            href={WA_PRUEBA}
            target="_blank"
            rel="noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            padding: "18px 40px",
            borderRadius: "50px",
            background: config.colors.brand,
            color: "#fff",
            fontWeight: 900,
            fontSize: "1.1rem",
            textDecoration: "none",
            boxShadow: "0 6px 20px rgba(124,58,237,0.4)",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
            e.currentTarget.style.boxShadow = "0 10px 30px rgba(124,58,237,0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "none";
            e.currentTarget.style.boxShadow = "0 6px 20px rgba(124,58,237,0.4)";
          }}
        >
          💬 HABLAR POR WHATSAPP
        </a>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer
      style={{
        padding: "32px 0",
        background: "#fff",
        borderTop: "1px solid #E5E7EB",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "8px",
          }}
        >
          <img src={logo} alt="Komity" style={{ height: "46px" }} />
        </div>
        <p style={{ fontSize: "0.8rem", color: config.colors.slateText, margin: 0 }}>
          © {new Date().getFullYear()} Komity. Software gastronómico de Chile.
          <br />
          <a
            href={`https://wa.me/${config.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            style={{ color: config.colors.slateText, textDecoration: "none" }}
          >
            WhatsApp
          </a>{" "}
          · contacto@komity.cl
        </p>
      </div>
    </footer>
  );
}

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function LandingKomity() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    setIsMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        color: config.colors.darkNavy,
        fontFamily: "'Inter', -apple-system, sans-serif",
        minHeight: "100vh",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
      `}</style>

      {/* MOBILE OVERLAY */}
      {isMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(11,17,32,0.6)",
            backdropFilter: "blur(4px)",
            zIndex: 1999,
          }}
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* MOBILE DRAWER */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: isMenuOpen ? 0 : "-300px",
          width: "280px",
          height: "100%",
          background: "#fff",
          zIndex: 2000,
          transition: "right 0.3s ease",
          boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <button
          onClick={() => setIsMenuOpen(false)}
          style={{
            alignSelf: "flex-end",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: config.colors.darkNavy,
          }}
        >
          ✕
        </button>
        <a
          href="#inicio"
          onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}
          style={{ fontWeight: 700, color: config.colors.darkNavy, textDecoration: "none", fontSize: "1rem" }}
        >
          Inicio
        </a>
        <a
          href="#como-funciona"
          onClick={(e) => { e.preventDefault(); scrollToSection('como-funciona'); }}
          style={{ fontWeight: 700, color: config.colors.darkNavy, textDecoration: "none", fontSize: "1rem" }}
        >
          Cómo funciona
        </a>
        <a
          href="#planes"
          onClick={(e) => { e.preventDefault(); scrollToSection('planes'); }}
          style={{ fontWeight: 700, color: config.colors.darkNavy, textDecoration: "none", fontSize: "1rem" }}
        >
          Planes
        </a>
        <a
          href="#faq"
          onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}
          style={{ fontWeight: 700, color: config.colors.darkNavy, textDecoration: "none", fontSize: "1rem" }}
        >
          FAQ
        </a>
        <a
          href="/adminlogin"
          style={{ fontWeight: 700, color: config.colors.darkNavy, textDecoration: "none", fontSize: "1rem" }}
        >
          Acceder
        </a>
        <div style={{ marginTop: "auto" }}>
          <a
            href={`https://wa.me/${config.whatsapp}?text=Hola! Quiero probar Komity Gratis.`}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "block",
              textAlign: "center",
              padding: "14px",
              borderRadius: "50px",
              background: `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})`,
              color: "#fff",
              fontWeight: 800,
              textDecoration: "none",
              fontSize: "0.85rem",
            }}
          >
            PROBAR GRATIS
          </a>
        </div>
      </div>

      {/* NAVBAR */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000,
          background: "rgba(255,255,255,0.9)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            padding: "0 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "64px",
          }}
        >
          <a
            href="#inicio"
            onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}
            style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
          >
            <img src={logo} alt="Komity" style={{ height: "60px" }} />
          </a>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
            className="nav-links"
          >
            <a
              href="#inicio"
              onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}
              style={{ fontSize: "0.85rem", fontWeight: 600, color: config.colors.slateText, textDecoration: "none" }}
            >
              Inicio
            </a>
            <a
              href="#como-funciona"
              onClick={(e) => { e.preventDefault(); scrollToSection('como-funciona'); }}
              style={{ fontSize: "0.85rem", fontWeight: 600, color: config.colors.slateText, textDecoration: "none" }}
            >
              Cómo funciona
            </a>
            <a
              href="#planes"
              onClick={(e) => { e.preventDefault(); scrollToSection('planes'); }}
              style={{ fontSize: "0.85rem", fontWeight: 600, color: config.colors.slateText, textDecoration: "none" }}
            >
              Planes
            </a>
            <a
              href="#faq"
              onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}
              style={{ fontSize: "0.85rem", fontWeight: 600, color: config.colors.slateText, textDecoration: "none" }}
            >
              FAQ
            </a>
            <a
              href="/adminlogin"
              style={{ fontSize: "0.85rem", fontWeight: 600, color: config.colors.slateText, textDecoration: "none" }}
            >
              Acceder
            </a>
          <a
            href={WA_PRUEBA}
            target="_blank"
            rel="noreferrer"
            style={{
              background: `linear-gradient(135deg, ${config.colors.action}, ${config.colors.brand})`,
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "50px",
              fontWeight: 700,
              fontSize: "0.8rem",
              textDecoration: "none",
              boxShadow: "0 4px 15px rgba(236,30,99,0.3)",
            }}
          >
            💬 CONTÁCTANOS
          </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(true)}
            style={{
              display: "none",
              background: "none",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
              color: config.colors.darkNavy,
            }}
            className="menu-toggle"
          >
            ☰
          </button>
        </div>
      </nav>

      <Hero />
      <ComoFunciona />
      <CapturasSistema />
      <Sectores />
      <Beneficios />
      <Planes />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}